module.exports = __webpack_public_path__ + "img/2.3accdf78.png";